import { render } from "./percentage.vue?vue&type=template&id=4b0c0a51&scoped=true&ts=true"
import script from "./percentage.vue?vue&type=script&lang=ts"
export * from "./percentage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0c0a51"]])

export default __exports__